import { useEffect, useRef } from 'react';
import _get from 'lodash/get';
import { ApiToken, useApiTokenQuery } from 'graphql-common';
import { ErrorLike } from '@apollo/client';

type Args = {
  id?: string;
  skip?: boolean;
  onError?: (error: ErrorLike) => void;
};

export type UseAssetCounterQueryHookResult = {
  data: ApiToken;
  loading: boolean;
  error: ErrorLike | undefined;
  refetch: () => void;
};

export default function useApiTokenQueryHook(
  args: Args,
): UseAssetCounterQueryHookResult {
  const { id = '', skip = true, onError } = args;
  const query = useApiTokenQuery({
    skip,
    variables: { id },
    fetchPolicy: 'network-only',
  });
  const { loading, error, refetch } = query;
  const data = _get(query, 'data.data') as ApiToken;

  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  useEffect(() => {
    if (error) {
      onErrorRef.current?.(error);
    }
  }, [error]);

  return {
    data,
    loading,
    error,
    refetch,
  };
}
